export default __webpack_public_path__ + "static/media/lock_icon.3e301b05.svg";